import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { PaymentAdvanceData } from '@/features/paymentAdvances/types/paymentAdvance.type'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

export type ReviewPaymentAdvanceParams = {
  id: string
  state: 'approve' | 'reject'
  reject_reason?: string
}

interface UseReviewPaymentAdvanceProps {
  onSuccess?: (response: AxiosResponse<{ data: PaymentAdvanceData }>) => void
  onError?: (error: ErrorResponse) => void
}

export const useReviewPaymentAdvance = ({ onSuccess, onError }: UseReviewPaymentAdvanceProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewPaymentAdvance'],
    mutationFn: async (params: ReviewPaymentAdvanceParams) => {
      const { id, state, reject_reason } = params

      const payload = {
        payment_advance: {
          reject_reason,
        },
      }

      return privateAxios.put(`/billing/payment_advances/${id}/${state}`, payload)
    },
    onSuccess,
    onError,
  })
}
